import { SPSELECTS } from "InterfacesTypes/enums";
import type { IPage } from "InterfacesTypes/interfaces";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchFailure,
  fetchCurrentNews,
  fetchStart,
  fetchSuccess,
} from "state/reducers/CurrentNewsReducer";
import { spGet } from "utils/SharepointAPI";
import { getEnvironment } from "utils/utils";

const env = getEnvironment();

function* fetchCurrentNewsWorker() {
  try {
    yield put(fetchStart());
    const currentNewsUrl = `${env.currentNewsUrl}/getbytitle('Webbplatssidor')/items?$top=3&$select=${SPSELECTS.CURRENTNEWS}&$orderBy=Created desc`;
    const data: IPage[] = yield call(spGet, currentNewsUrl);
    yield put(fetchSuccess(data));
  } catch (err: any) {
    yield put(fetchFailure(err?.message ?? "Något gick fel"));
  }
}

export function* currentNewsSaga() {
  yield takeLatest(fetchCurrentNews.type, fetchCurrentNewsWorker);
}
